import type { ReactNode } from 'react';
import type { Role } from '@attendance/shared';
import { useAuthStore } from '../../stores/authStore.js';

export function RoleGate({
  allow,
  children,
  fallback = null,
}: {
  allow: Role[];
  children: ReactNode;
  fallback?: ReactNode;
}): JSX.Element {
  const role = useAuthStore((s) => s.user?.role);
  if (!role || !allow.includes(role)) return <>{fallback}</>;
  return <>{children}</>;
}
